import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const FeesComponent = () => {
  return (
    <section className="mx-4 md:mx-24 lg:mx-48 bg-white py-8 md:py-20 px-8 md:px-16 rounded-3xl mt-4 md:mt-16">
      {/* Section 1 - Introduction */}
      <motion.div 
        className="text-center mb-8"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2 className="text-2xl md:text-3xl font-bold text-acBlack">
          Transparent Fees, No Hidden Costs
        </h2>
        <p className="text-md text-acGray font-light">
          We ensure that our pricing is fair, clear, and results-driven-giving you confidence in every step of the recovery process.
        </p>
      </motion.div>

      {/* Section 2 - Pricing Breakdown */}
      <motion.div 
        className="grid md:grid-cols-2 gap-12 mb-12"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {/* Administrative Fee */}
        <div className="shadow-md p-6 rounded-lg shadow-md">
          <h3 className="text-lg font-bold text-acBlack mb-2">
            Case Investigation & Administrative Fee
          </h3>
          <p className="text-md text-acGray">
            <span className="font-bold">$3,500 (One-Time Payment)</span>  
            <br />
            This covers:
          </p>
          <ul className="list-disc text-acGray text-sm mt-3 pl-5">
            <li>Full case assessment & legal groundwork</li>
            <li>Private investigation from origin to destination country</li>
            <li>Evidence collection for law enforcement & regulators</li>
            <li>Fast-tracked asset recovery & intervention</li>
          </ul>
        </div>

        {/* Success-Based Fee */}
        <div className="shadow-md p-6 rounded-lg shadow-md">
          <h3 className="text-lg font-bold text-acBlack mb-2">
            Success-Based Recovery Fee
          </h3>
          <p className="text-md text-acGray">
            <span className="font-bold">10% of Recovered Funds (Capped at $30,000)</span>  
            <br />
            We only charge a percentage of recovered funds. If we recover more than $300,000, the highest we can charge is $30,000.
          </p>
          <ul className="list-disc text-acGray text-sm mt-3 pl-5">
            <li>No hidden fees - you only pay if we recover your funds </li>
            <li>Aligned interests - we succeed when you do**</li>
            <li>Expert legal, investigative & regulatory guidance</li>
          </ul>
        </div>
      </motion.div>

      {/* Section 3 - Why Our Pricing Works */}
      <motion.div 
        className="text-left mb-12"
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h3 className="text-sm font-semibold text-acBlack uppercase mb-2">
          Why Our Pricing Model Works
        </h3>
        <h2 className="text-3xl font-bold text-acBlack mb-4">
          Fair, Transparent & Success-Driven
        </h2>
        <p className="text-md text-acGray">
          We work with top-tier forensic investigators, and financial crime specialists to track, dispute, and recover stolen funds. Our fees ensure that we can mobilize resources, accelerate asset tracing, and engage authorities efficiently increasing your chances of successful recovery.
        </p>
      </motion.div>

      {/* Section 4 - Additional Value & Global Reach */}
      <motion.div 
        className="grid md:grid-cols-2 gap-8 text-left mb-12"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {/* Global Investigations */}
        <div className="shadow-md p-6 rounded-lg shadow-md">
          <h3 className="text-lg font-bold text-acBlack mb-2">
            Global Investigations & Asset Recovery
          </h3>
          <p className="text-md text-acGray">
            We collaborate with **government agencies, private investigators, and financial institutions across Europe, North America, Asia, and Australia** to track fraudulent transactions.
          </p>
        </div>

        {/* Law Enforcement Partnerships */}
        <div className="shadow-md p-6 rounded-lg shadow-md">
          <h3 className="text-lg font-bold text-acBlack mb-2">
            Working with Law Enforcement & Regulators
          </h3>
          <p className="text-md text-acGray">
            Our team partners with financial watchdogs, cybercrime divisions, and fraud recovery units, eliminating bureaucratic delays and securing rapid case escalation.
          </p>
        </div>
      </motion.div>

      {/* CTA Button */}
      <motion.div 
        className="text-center"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <Link to="/start-claim">
          <button className="px-6 py-3 bg-acBlack text-white rounded-full font-medium hover:opacity-80 transition">
            Start Your Claim Today
          </button>
        </Link>
      </motion.div>
    </section>
  );
};

export default FeesComponent;
